import React from "react";
import Context from "../../../Context";
import Blocker from "../../Misc/Blocker";

import { DragDropContext, Droppable, Draggable } from "react-beautiful-dnd";
import EssenceStateLabel from "../../Essence/EssenceStateLabel";
import EssenceActionsDropdown from "../../Essence/EssenceActionsDropdown";
import SpecProjShip from "./SpecProjShip";

export default class SpecTree extends React.Component {
  static contextType = Context;
  constructor(props) {
    super(props);
    this.state = {
      pending: false,
      activeItemId: this.props.itemId || null,
      items: {},
      itemsShowAll: false,
      itemStateSearchDefault: [
        {
          lstr: "(",
          field: "statetypecode",
          compare: "EQL",
          value: "enabled",
          rstr: ")",
        },
      ],
      itemStateSearchAll: [],
    };
  }
  componentDidMount() {
    this.load();
  }
  componentDidUpdate(prevProps) {
    if (
      prevProps.projectId !== this.props.projectId ||
      prevProps.shipId !== this.props.shipId ||
      prevProps.customListKey !== this.props.customListKey
    ) {
      this.load();
    }
    if (prevProps.itemId !== this.props.itemId) {
      this.setState({ activeItemId: this.props.itemId });
    }
  }
  load = async () => {
    const { projectId, shipId } = this.props;
    this.setState({ pending: true });

    let search = this.state.itemsShowAll
      ? [...this.state.itemStateSearchAll]
      : [...this.state.itemStateSearchDefault];

    let items = await this.context.api.qoo(
      `/specification/tree`,
      { project: projectId, ship: shipId, search },
      undefined,
      undefined,
      undefined,
      "node",
      "sequence"
    );

    this.setState({ pending: false, items });
  };
  onDragEnd = async (eventResult) => {
    const { draggableId, destination, source } = eventResult;
    const { items } = this.state;
    if (!eventResult.destination || !draggableId) {
      return;
    }

    const isUp = source.index > destination.index;
    const isDown = source.index < destination.index;

    if (!isUp && !isDown) return;

    const cIndex = isDown ? destination.index : destination.index - 1;

    const prevItem = items[Object.keys(items)[cIndex]] || false;
    const nextItem = items[Object.keys(items)[cIndex + 1]] || false;
    const currItem = items[`_${draggableId}`] || false;

    let node = null;
    let sequence = 1;

    if (prevItem.level < nextItem.level) {
      node = nextItem.node;
      sequence = 1;
    } else if (prevItem.level > nextItem.level || !nextItem) {
      node = prevItem.node;
      sequence = prevItem.sequence + 1;
    } else {
      node = nextItem.node;
      sequence = isUp ? nextItem.sequence : prevItem.sequence;
    }

    if (currItem.node === null) node = null;

    let saveData = {
      id: draggableId,
      node: node === null ? 0 : node,
      sequence,
    };

    this.setState({ pending: true });

    let result = await this.context.api.q(`/specification/set`, saveData);
    if (result !== false) {
      this.context.toast("Позиция элемента изменена", "success");
      await this.load();
    } else {
      this.context.toast("Не удалось изменить позицию элемента", "error");
      this.setState({ pending: false });
    }
  };
  onItemClick = (item) => {
    const { shipId, projectId } = this.props;
    this.context.redirect(`/spec/${projectId}/${shipId}/${item.id}`);
  };
  onShowAllToggle = (e) => {
    this.setState({ itemsShowAll: !e.target.checked }, () => this.load());
  };
  onDrop = () => {
    const { shipId, projectId } = this.props;
    this.context.redirect(`/spec/${projectId}/${shipId}/`);
    this.load();
  };
  render() {
    const itemsListDraggable = (
      <div className="table-responsive-no">
        <DragDropContext onDragEnd={this.onDragEnd}>
          <table className="table">
            <Droppable droppableId="droppable">
              {(provided, snapshot) => (
                <tbody {...provided.droppableProps} ref={provided.innerRef}>
                  {Object.entries(this.state.items).map(([id, item], index) => (
                    <Draggable
                      key={item.id}
                      draggableId={String(item.id)}
                      index={index}
                    >
                      {(provided, snapshot) => {
                        const isActive =
                          item.id === this.state.activeItemId ? true : false;

                        const padding = item.structureLevel
                          ? `pl-${item.structureLevel * 5}`
                          : "";

                        const dragging = snapshot.isDragging
                          ? "bg-light d-table "
                          : "";

                        const isShippy = item.ship ? true : false;
                        const isVisible = item.visible ? true : false;
                        return (
                          <tr
                            ref={provided.innerRef}
                            {...provided.draggableProps}
                            {...provided.dragHandleProps}
                            onClick={() => this.onItemClick(item)}
                            key={id}
                            className={`bg-hover-light cursor-pointer 
                            ${isShippy ? "font-italic text-dark-50" : ""}
                            ${isActive ? "bg-light" : ""}  
                            
                            ${padding} ${dragging}`}
                          >
                            <td
                              width="45%"
                              ref={isActive ? this.state.activeItemRef : null}
                              className={`${padding}`}
                            >
                              {!isVisible && (
                                <i className="fa fa-eye-slash mr-2 text-muted"></i>
                              )}
                              {item.name}
                            </td>
                            <td width="10%" className="text-right text-nowrap">
                              {this.state.itemsShowAll ? (
                                <EssenceStateLabel
                                  stateCode={item.statetypecode}
                                  stateLabel={item.statelabel}
                                  essence={"specification"}
                                  id={item.id}
                                />
                              ) : null}

                              <div className="d-inline-block align-middle ml-2">
                                <EssenceActionsDropdown
                                  className="px-2"
                                  essence={"specification"}
                                  key={`${item.id}${item.state}`}
                                  id={item.id}
                                  label={item.label}
                                  onFinish={() => this.load()}
                                  onDrop={this.onDrop}
                                  onPending={(pending) => {
                                    if (pending)
                                      this.setState({ pending: true });
                                  }}
                                />
                              </div>
                            </td>
                          </tr>
                        );
                      }}
                    </Draggable>
                  ))}
                  {provided.placeholder}
                </tbody>
              )}
            </Droppable>
          </table>
        </DragDropContext>
      </div>
    );

    return (
      <>
        <Blocker on={this.state.pending}>
          <div className="d-flex align-items-center mb-5">
            <SpecProjShip {...this.props} />
            <div className="text-nowrap d-inline-block pl-4">
              <label
                title="Показывать в любом статусе"
                className="checkbox text-muted font-italic"
              >
                <input
                  checked={!this.state.itemsShowAll}
                  onChange={this.onShowAllToggle}
                  type="checkbox"
                />
                <span className="mr-2"></span>
                Только активные
              </label>
            </div>
          </div>
          {itemsListDraggable}
        </Blocker>
      </>
    );
  }
}
